const axios = require('axios');
const { errorMapper } = require('../ErrorMapper');

const CURRENT_VERSION = 'v1';
const URI = `/${CURRENT_VERSION}/guests`;

class CorporationGuestServiceConnector {
  constructor(configuration) {
    this.httpClient = axios.create(configuration);
  }

  async createGuest(options = {}) {
    try {
      const request = {
        url: URI,
        method: 'POST',
        ...options,
      };

      const { data } = await this.httpClient(request);
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async updateGuest(guest) {
    try {
      const request = {
        url: `${URI}/${guest.id}`,
        method: 'PATCH',
        data: {
          givenName: guest.givenName,
          familyName: guest.familyName,
          email: guest.email,
          phone: guest.phone,
        },
      };

      const { data } = await this.httpClient(request);
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async listGuests(params) {
    try {
      const { data, headers } = await this.httpClient.get(URI, {
        params,
      });
      return { data, headers };
    } catch (error) {
      return this._handleError(error);
    }
  }

  _handleError(error) {
    throw errorMapper(error);
  }
}

module.exports = {
  CorporationGuestServiceConnector,
};
